import { useCallback, useEffect, useRef, useState } from 'react';
import { API_CORE } from '../../../../../_CORE/API/ApiCORE';
import { PORTFOLIO_PUBLIC_CONSTANTS } from '../_MODULES/_API';

export const usePortfolio = () => {
    const [data, setData] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const lastAutoReload = useRef(0);

    const load = useCallback(async ({ silent = false } = {}) => {
        if (!silent) setIsLoading(true);
        setError(null);

        const endpoint = API_CORE.ENDPOINTS[PORTFOLIO_PUBLIC_CONSTANTS.GET];
        const response = await API_CORE.SERVICES.GET_RESOURCE(endpoint, {
            params: { _portfolio_refresh: Date.now() },
        });
        const status = response?.status ?? response?.code_status ?? 500;

        if (response?.success === true && response?.data) {
            setData(response.data);
            setIsLoading(false);
            return response.data;
        }

        if (!silent) setData(null);
        setError({
            status,
            message: response?.message || 'No se pudo cargar el portfolio.',
        });
        setIsLoading(false);
        return null;
    }, []);

    useEffect(() => {
        load();

        const reloadIfNeeded = () => {
            if (document.visibilityState && document.visibilityState !== 'visible') return;
            const now = Date.now();
            if (now - lastAutoReload.current < 500) return;
            lastAutoReload.current = now;
            load({ silent: true });
        };

        const reloadFromStorage = (event) => {
            if (event.key === 'portfolio:last-update') reloadIfNeeded();
        };

        window.addEventListener('focus', reloadIfNeeded);
        window.addEventListener('storage', reloadFromStorage);
        document.addEventListener('visibilitychange', reloadIfNeeded);
        return () => {
            window.removeEventListener('focus', reloadIfNeeded);
            window.removeEventListener('storage', reloadFromStorage);
            document.removeEventListener('visibilitychange', reloadIfNeeded);
        };
    }, [load]);

    return { data, isLoading, error, reload: load };
};
